import { Box } from '@mui/material';
import { CerebroPill } from './CerebroPill';

// Like a partial React.ChangeEvent because formik falls back to handling any value it receives on change as an event if it isn't a string.
interface TangileAssetTypeInputChangeEvent {
	target: {
		name: string;
		value: string;
	};
}

interface TangibleAssetTypeInputProps {
	name: string;
	error?: boolean;
	value: string | null;
	onChange: (event: TangileAssetTypeInputChangeEvent) => void;
}

export const TangibleAssetTypeInput: React.FC<TangibleAssetTypeInputProps> = ({
	name,
	error = false,
	value,
	onChange,
}) => {
	const onClick = (newValue: string) => {
		// Only call the onChange if the value is actually changing.
		if (newValue !== value) onChange({ target: { name, value: newValue } });
	};
	//'NotApplicable' | 'New' | 'Used';
	return (
		<Box
			sx={{
				marginBottom: 1,
				marginTop: 1.5,
			}}
		>
			<CerebroPill
				error={error}
				selected={value === 'New'}
				onClick={() => onClick('New')}
				sx={{ marginRight: 1 }}
			>
				New
			</CerebroPill>
			<CerebroPill
				error={error}
				selected={value === 'Used'}
				onClick={() => onClick('Used')}
				sx={{ marginRight: 1 }}
			>
				Used
			</CerebroPill>
			<CerebroPill error={error} selected={value === 'NotApplicable'} onClick={() => onClick('NotApplicable')}>
				N/A
			</CerebroPill>
		</Box>
	);
};
